import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseService } from 'src/app/core/services/base.service';
import { CacheResolverService } from '../../core/cache/cache-resolver.service';
import { HttpHeader} from '../../core/constants/app.constant';
import { CacheConstant } from 'src/app/core/cache/cache.constant';
import { OktaAuth } from 'src/app/shared/models/app';
import jwt_decode from 'jwt-decode';
import { environment } from '../../../environments/environment';
import { Environment } from 'src/app/shared/models/environment';
import { EncryptionService } from '../../../app/core/services/encryption.service';
import jwtDecode from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class TokenService extends BaseService {
  public environment = Environment.getInstance();

  constructor(
    http: HttpClient, private readonly cacheService: CacheResolverService, private encryptionService: EncryptionService
  ) {
    super(http);
  }

  public saveJWT(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  public getJWT(key: string) {
    return localStorage.getItem(key)
  }

  public getDecodedAccessToken(token: string): any {
    try {
      return jwt_decode(token);
    } catch(Error) {
      return null;
    }
  }

  public clearData() {
    localStorage.clear();
  }

  get(): OktaAuth {
    return this.getAuthToken();
  }

  set(token: string, expiresAt: Date = null): void {
    expiresAt = expiresAt || this.addHours(new Date(), 1);

    const oktaAuth = this.getAuthToken();
    oktaAuth.accessToken = token;
    oktaAuth.expiresAt = expiresAt;
    this.cacheService.set(CacheConstant.OktaAuth, oktaAuth, 60 * 60 * 1);
  }

  getQueryToken() {
    const urlParams = new URLSearchParams(window.location.search);
    const queryParamToken = urlParams.get(HttpHeader.Token);
    return queryParamToken;
  }

  exist() {
    const queryParamToken = this.getQueryToken();
    const oktaAuthCache = this.get();
    const token = queryParamToken || oktaAuthCache.accessToken;

    if (queryParamToken) {
      this.set(token);
    }
    return token;
  }

  validate(accessToken: string, idToken: string) {
    var options = {
      headers: new HttpHeaders()
        .set('Authorization', `Bearer ${idToken}, Bearer ${accessToken}`)
    }
    return this.http.post<any>
      (
       this.environment.apiConfig.jwtUrl,
        null,
        options
      )
  }

  addHours(date: Date, hours: number): Date {
    date.setTime(date.getTime() + hours * 60 * 60 * 1000);
    return date;
  }

  getTokenExpiry() {
    const accessToken = this.cacheService.get(CacheConstant.OktaAuth)['access_token'];
    const tokenDetails = jwtDecode<any>(accessToken);
    return tokenDetails['exp'] * 1000;
  }
  
  private getAuthToken(): OktaAuth {
    let oktaAuth = this.cacheService.get(CacheConstant.OktaAuth) as OktaAuth;
    if (!oktaAuth) {
      oktaAuth = {
        accessToken: null,
        expiresAt: null,
      };
    }

    return oktaAuth;
  }
}
